import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDateTime', (value) => {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
})

Vue.filter('formatDate', (value) => {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDateLong', (value) => {
  if (value) {
    return moment(String(value)).format('DD MMM YYYY')
  }
})

Vue.filter('formatDateAgo', (value, suppressSuffix) => {
  if (value) {
    return moment(String(value)).fromNow(suppressSuffix)
  }
})

Vue.filter('formatComment', (message) => {
  if (/Moved to/.test(message)) {
    return message
  } else if (/Ticket created/.test(message)) {
    return message
  } else if (!message) {
    return 'No comment'
  } else {
    return 'Comment added'
  }
})

Vue.filter('toFileSize', (value) => {
  if (typeof value !== 'number') {
    value = parseFloat(value)
  }

  let e = (Math.log(value) / Math.log(1e3)) | 0
  return +(value / Math.pow(1e3, e)).toFixed(1) + ' ' + ('kMGTPEZY'[e - 1] || '') + 'B'
})

Vue.filter('toCurrencyWithCents', (value) => {
  if (value && typeof value !== 'number') {
    value = parseFloat(value.replace(/[^\d.-]/g, '')) || 0.0
  }
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })
  return formatter.format(value || 0)
})



// WEBPACK FOOTER //
// ./src/filters.js